import { render, staticRenderFns } from "./LabellingChartPanel.vue?vue&type=template&id=523f3bad&scoped=true&"
import script from "./LabellingChartPanel.vue?vue&type=script&lang=js&"
export * from "./LabellingChartPanel.vue?vue&type=script&lang=js&"
import style0 from "./LabellingChartPanel.vue?vue&type=style&index=0&id=523f3bad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f3bad",
  null
  
)

export default component.exports